
app.pagesController = app.pagesController || {};
app.pagesController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.slider_resize();
        this.minHeightContent();
        this.slidersPlannings();
        this.ancresTab();
        this.sliderLanding();
        this.sameHeightOffreBlock();
        this.handleOffre();
        this.sliderHeroLanding();
        this.handleBulle();
    },

    slider_resize : function () {
        var slider = $('.metaslider');
        var sliderContent = slider.find('.flexslider');
        var sliderWidth = slider.width();

        sliderContent.height(sliderWidth / 2);

        $( window ).resize(function() {
            sliderWidth = slider.width();
            sliderContent.height(sliderWidth / 2);
        });
    },

    minHeightContent : function () {
        var self = this;

        self.resizeHeightContent();

        $( window ).resize(function() {
            self.resizeHeightContent();
        });
    },

    resizeHeightContent: function () {
        var mainContent = $('.main-content');
        var content = mainContent.find('.content');
        var title = mainContent.find('.page-title');
        var nav = mainContent.find('.nav-top');
        var header = $('header');
        var footer = $('footer');

        if ( window.matchMedia("(max-width: 769px)").matches) {
            if ($('#wpadminbar').length) {
                mainContent.css('min-height', 'calc(100vh - ' + (footer.height() + 70) + 'px - 190px - ' + $('#wpadminbar').height() + 'px)');
            } else {
                mainContent.css('min-height', 'calc(100vh - ' + (footer.height() + 70) + 'px - 190px)');
            }
        } else if (window.matchMedia("(max-width: 1025px)").matches) {
            if ($('#wpadminbar').length) {
                mainContent.css('min-height', 'calc(100vh - ' + (footer.height() + 40) + 'px - 210px - ' + $('#wpadminbar').height() + 'px)');
            } else {
                mainContent.css('min-height', 'calc(100vh - ' + (footer.height() + 40) + 'px - 210px)');
            }
        } else {
            if ($('#wpadminbar').length) {
                mainContent.css('min-height', 'calc(100vh - ' + (header.height() + 20) + 'px - ' + (footer.height() + 40) + 'px - 80px - ' + $('#wpadminbar').height() + 'px)');
            } else {
                mainContent.css('min-height', 'calc(100vh - ' + (header.height() + 20) + 'px - ' + (footer.height() + 40) + 'px - 80px)');
            }
        }
        if ($('.nav-top').length) {
            content.css('min-height', 'calc(' + mainContent.css('min-height') + ' - ' + (title.height() + 60) + 'px - ' + nav.height() + 'px)');
        } else {
            content.css('min-height', 'calc(' + mainContent.css('min-height') + ' - ' + (title.height() + 60) + 'px)');
        }



    },

    slidersPlannings : function () {
        $('.planning-content').slick({
            infinite: true,
            arrows: false,
            adaptiveHeight: true
        });

        $('.planning-content .prev-day').on('click', function() {
            $('.planning-content').slick('slickPrev');
        });

        $('.planning-content .next-day').on('click', function() {
            $('.planning-content').slick('slickNext');
        });
    },

    ancresTab : function () {
        if ($( ".univers-links" ).length) {
            var container = $('.univers-links');

            $(".tablepress").each(function(){
                var id_element = $(this).attr('id');
                var title_element = $(this).find('thead .row-1 .column-1').text();
                var color_element = 'color-white';

                if ($(this).hasClass('color-blue')) {
                    color_element = 'color-blue';
                }
                if ($(this).hasClass('color-green')) {
                    color_element = 'color-green';
                }
                if ($(this).hasClass('color-yellow')) {
                    color_element = 'color-yellow';
                }
                if ($(this).hasClass('color-pink')) {
                    color_element = 'color-pink';
                }
                if ($(this).hasClass('color-purple')) {
                    color_element = 'color-purple';
                }

                container.append('<a href="#' + id_element + '" class="' + color_element + '">' + title_element + '</a>');
            });

            $(".planning_univers").each(function(){
                var id_element = $(this).attr('id');
                var title_element = $(this).find('.title-planning').text();
                var color_element = 'color-white';

                if ($(this).find('.planning').hasClass('color-blue')) {
                    color_element = 'color-blue';
                }
                if ($(this).find('.planning').hasClass('color-green')) {
                    color_element = 'color-green';
                }
                if ($(this).find('.planning').hasClass('color-yellow')) {
                    color_element = 'color-yellow';
                }

                container.append('<a href="#' + id_element + '" class="' + color_element + '">' + title_element + '</a>');
            });
        }
    },

    sliderLanding : function () {
        $('.slide-wrap').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            // variableWidth: true,
            // centerMode: true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            }]
    });
    },

    sliderHeroLanding : function () {
        $('.slide-hero-wrap').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: false,
            nextArrow: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 2000,
        });
    },

    handleBulle: function() {

        $(window).scroll(function() {
            var carteEl = $('.carte-interactive.not-animate');

            var marker = $('.map-dot svg');
            var scrollTop = $(document).scrollTop();
            var viewportHeight = $(window).height();

            if (carteEl.length > 0) {
                var targetPosition = carteEl.position().top;
                var targetHeight = carteEl.outerHeight();

                if(scrollTop + viewportHeight < targetPosition) {
                    // not in viewport
                    // carteElNotAnimate.addClass("not-animate");
                    // console.log('test not in viewport 1');
                } else if(scrollTop + viewportHeight < targetPosition + targetHeight) {
                    // partially in viewport
                } else if(scrollTop> targetPosition + targetHeight) {
                    // not in viewport
                    // console.log('test not in viewport 2');
                    //
                    // carteElNotAnimate.addClass("not-animate");
                } else if(scrollTop > targetPosition) {
                    // partially in viewport
                } else {
                    carteEl.removeClass("not-animate");
                    marker.animate({
                        height: "45px",
                        width: "45px",
                    }, 400, function() {
                        marker.animate({
                            height: "35px",
                            width: "35px",
                        },400);
                    });
                }
            }

            // viewport stretches from scrollTop to (scrollTop + viewportHeight)

        });

        $(".map-dot").mouseenter(function(){
            $(this).find(".bulle").css("display",'block');
        });
        $(".map-dot").mouseleave(function(){
            $(this).find(".bulle").css("display",'none');
        });
    },

    sameHeightOffreBlock: function () {
        $('.page-template-template-tarif .offre-titre').matchHeight({property: 'min-height'});
        $('.page-template-template-tarif .offre-prix-wrapper').matchHeight({property: 'min-height'});
        $('.page-template-template-tarif .offre-acces').matchHeight({property: 'min-height'});
        $('.page-template-template-tarif .offre-modalite').matchHeight({property: 'min-height'});
    },

    handleOffre: function () {

        var offre = $('.page-template-template-tarif li.offre');

        offre.click(function() {

            var height = $(this)[0].scrollHeight;

            if($(this).hasClass('open')) {
                $(this).animate({
                    maxHeight: "136px"
                } ,200);
            } else {
                $(this).animate({
                    maxHeight: height
                },200);
            }

            $(this).toggleClass('open');
        });

        $( window ).resize(function() {
            if (window.matchMedia('(min-width: 420px)').matches) {
                offre.css("max-height", "none");
            } else {
                offre.css("max-height", "136px");
            }
        });
    }


};
